<div class="p-4 flex flex-col items-center text-center">
    <h2>Seite nicht gefunden</h2>
    <p class="mb-3">Die aufgerufene Adresse existiert nicht.</p>
    <div class="flex justify-center">
        <button pButton type="button" icon="fas fa-home" label="Zur Startseite" (click)="goHome()"></button>
    </div>
</div>